import React from 'react';
import axios from 'axios';
import { Table} from 'semantic-ui-react';
import { NoData } from "../../components/table/no-data";
import ApiDataProvider from "../../components/table/data-providers/api-data-provider";

import { apiUrl } from "../../config.js"
import * as api from '../../api'
import DataMapAccessModal from './datamapaccess';

class DataMapsAdminTableRow extends React.Component {
    
    constructor(props) {
        super(props);

        this.state = {
            dataProvider: new ApiDataProvider(api.getCustomerMeters, [this.props.customerId]),
            metersCount: {},
            completenessData: [],
            gasMeterCount: [],
            elecMeterCount: [],
            waterMeterCount: [],

            UpdateMe: "ready",
            showInfoHide: false,
            showErrorHide: true,
            showSuccessHide: true,
            uploadStatusList: ["error1", "error2"],
            downloadingFile : false,
            meterModalOpen : false
        }
    }


    setOpen = (open) => {
        if(open === false)
        {
            this.setState({
        
                showInfoHide : false,
                showErrorHide : true,
                showSuccessHide  : true,
            });
        }
        this.setState({
        
            meterModalOpen : open
        });
    }

    downloadDocument = (mapName) => {
        this.setState({
        
            downloadingFile : true
        });
        axios({
            url: `${apiUrl}/DataMaps/GetMapData/${mapName}`,
            method: 'POST',       // Worked using POST or PUT. Prefer POST
            headers: {
                'Authorization': `bearer ${localStorage.getItem("token")}`
            },
            responseType: 'blob', // important
        }).then((response) => {
            this.setState({
        
                downloadingFile : false
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', mapName + '.csv');
            document.body.appendChild(link);
            link.click();
        });
    }

    render() {
        

        return (
            <Table.Row>
                <Table.Cell>{this.props.data.name || <NoData />}</Table.Cell>
                <Table.Cell>{this.props.data.description || <NoData />}</Table.Cell>
                <Table.Cell>{this.props.data.mapSource || <NoData />}</Table.Cell>
                <Table.Cell>
               

<DataMapAccessModal mapSource={this.props.data.id } mapName={this.props.data.mapSource} notifyParent={this.notifyParent} />
        </Table.Cell>
            </Table.Row>
        );
    }
}

export default DataMapsAdminTableRow;